// What a client reads after uploading scope files, composed from what
// happened to each one.
//
// It is a pure function on purpose: the upload cannot be exercised anywhere
// else. Submitting the form launches real jobs on the legacy service, in a
// test as on staging, so the message is the only part of it that can be held
// by a test.
//
// Until 2026-09-25 the reasons were collected and never shown: the summary
// said "Revisa los mensajes y vuelve a intentar" and there were no messages
// on screen, which is what the owner hit when a file was rejected.

// When the back answers something the portal does not recognise. The reason
// used to be the literal word "Error", which is neither Spanish nor useful.
export const GENERIC_UPLOAD_FAILURE = 'No fue posible cargar el archivo. Intente de nuevo.';

const listed = (failures) => failures
  .map(({ file, reason }) => `• ${file}: ${reason || GENERIC_UPLOAD_FAILURE}`)
  .join('\n');

// results: [{ file, ok, reason }], one per file, in the order they were sent.
// Returns the message and the severity the alert takes, or null when there is
// nothing to say.
export const uploadSummary = (results, email) => {
  if (!results || results.length === 0) return null;

  const done = results.filter((r) => r.ok);
  const failures = results.filter((r) => !r.ok);

  if (failures.length === 0) {
    const what = done.length === 1 ? 'Se cargó correctamente 1 archivo.' : `Se cargaron correctamente ${done.length} archivos.`;
    return {
      message: `${what} Pronto al correo ${email} recibirás el alcance generado.`,
      severity: 'success',
    };
  }

  if (done.length > 0) {
    return {
      message: `Se cargaron ${done.length} de ${results.length} archivos. No se pudieron cargar:\n${listed(failures)}`,
      severity: 'warning',
    };
  }

  if (results.length === 1) {
    const { file, reason } = failures[0];
    return {
      message: `No se pudo cargar ${file}: ${reason || GENERIC_UPLOAD_FAILURE}`,
      severity: 'danger',
    };
  }

  return {
    message: `No se pudo cargar ningún archivo:\n${listed(failures)}`,
    severity: 'danger',
  };
};
